import { createResource } from '@gandi/resource/redux';
const sharingResource = createResource('sharing');
export default sharingResource;